import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  isMaximized: false,
  isParentView: false,
  isFirstHovered: true,
  visibleMascot: true,
  isMobileWindow: false,
  appSSID: null,
  conversationID: null,
  conversationStopped: false,
};

export const windowSlice = createSlice({
  name: "window",
  initialState,
  reducers: {
    setIsOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    setIsMaximized: (state, action) => {
      state.isMaximized = action.payload;
    },
    setIsParentView: (state, action) => {
      state.isParentView = action.payload;
    },
    setIsFirstHovered: (state, action) => {
      state.isFirstHovered = action.payload;
    },
    setVisibleMascot: (state, action) => {
      state.visibleMascot = action.payload;
    },
    setIsmobileWindow: (state, action) => {
      state.isMobileWindow = action.payload;
    },
    setAppSSID: (state, action) => {
      state.appSSID = action.payload;
    },
    setConversationID: (state, action) => {
      state.conversationID = action.payload;
    },
    setConversationStopped: (state, action) => {
      state.conversationStopped = action.payload;
    },
  },
});

export const getIsOpen = (state) => state.window.isOpen;
export const getIsParentView = (state) => state.window.isParentView;
export const getIsMaximized = (state) => state.window.isMaximized;
export const getIsFirstHovered = (state) => state.window.isFirstHovered;
export const getVisibleMascot = (state) => state.window.visibleMascot;
export const getIsMobileWindow = (state) => state.window.isMobileWindow;
export const getAppSSID = (state) => state.window.appSSID;
export const getConversationID = (state) => state.window.conversationID;
export const getConversationStopped = (state) => state.window.conversationStopped;
export const {
  setIsOpen,
  setIsMaximized,
  setIsParentView,
  setIsFirstHovered,
  setVisibleMascot,
  setIsmobileWindow,
  setAppSSID,
  setConversationID,
  setConversationStopped,
} = windowSlice.actions;

export default windowSlice.reducer;
